export const DASHBOARD_API_ENDPOINT = {
	TOTAL_CASES_BY_STATUS_MOBILE: "dashboard/total-cases-by-status-from-mobile",
	TOTAL_CASES_STATUS_BY_SERVICE_ADMIN:
		"dashboard/total-cases-status-by-service-admin",
	ENGINEER_WORK_ORDER_STATUS: "dashboard/engineer-work-order-status",
	CASES_STATUS_BY_AGENCIES: "dashboard/cases-status-by-agencies",
	WORK_ORDER_STATUS_BY_AGENCIES: "dashboard/work-order-status-by-agencies",
	TOTAL_AGING_CASES: "dashboard/total-aging-cases",
	BILLABLE_BY_SERVICE_CATEGORIES:
		"dashboard/billable-and-non-by-service-categories",
	MTD_OUTSTANDING_CM:
		"dashboard/mtd-outstanding-cm-by-team-and-service-categories",
	MTD_OUTSTANDING_CM_BY_SERVICE_CATEGORIES_AND_TEAM:
		"dashboard/mtd-outstanding-cm-by-service-categories-and-team",
	TOP_10_CUSTOMER_SERVICE_BREAKDOWN:
		"dashboard/top-10-customer-service-breakdown",
	SERVICE_BREAKDOWN: "dashboard/service-breakdown",
	ENGINEER_UTILIZATION: "dashboard/engineer-utilization",
	ENGINEER_UTILIZATION_FUNC_OPC:
		"dashboard/engineer-utilization-functional-opc",
	ENGINEER_PRODUCTIVITY_DISTRIBUTION:
		"dashboard/engineer-productivity-distribution",
	TOP_BAR: "dashboard/top-bar",
	TOTAL_WORK_ORDER_BY_STATUS: "dashboard/total-work-orders-by-status",
	TOTAL_CASES_BY_STATUS: "dashboard/total-cases-by-status",
	CASES_BY_ORIGIN: "dashboard/cases-by-origin",
	TOTAL_CASES_BY_STATUS_REASON: "dashboard/total-cases-by-status-reason",
	TOTAL_WORK_ORDERS_BY_STATUS_REASON:
		"dashboard/total-work-orders-by-status-reason",
	CASES_STATUS_BY_SERVICE_CATEGORIES:
		"dashboard/cases-status-by-service-categories",
	WORK_ORDERS_STATUS_BY_SERVICE_CATEGORIES:
		"dashboard/work-orders-status-by-service-categories",
	CASES_STATUS_BY_TEAMS: "dashboard/cases-status-by-teams",
	WORK_ORDERS_STATUS_BY_TEAMS: "dashboard/work-orders-status-by-teams",
	CASES_STATUS_BY_FUNCTIONAL_TEAMS:
		"dashboard/cases-status-by-functional-teams",
	WORK_ORDERS_STATUS_BY_FUNCTIONAL_TEAMS:
		"dashboard/work-orders-status-by-functional-teams",
	CASES_STATUS_BY_REGIONS: "dashboard/cases-status-by-regions",
	WORK_ORDERS_STATUS_BY_REGIONS: "dashboard/work-orders-status-by-regions",
	CASES_STATUS_BY_REGIONS_AND_TEAMS:
		"dashboard/cases-status-by-regions-and-teams",
	WORK_ORDERS_STATUS_BY_REGIONS_AND_TEAMS:
		"dashboard/work-orders-status-by-regions-and-teams",
	CASES_STATUS_BY_REGIONS_AND_FUNCTIONAL_TEAMS:
		"dashboard/cases-status-by-regions-and-functional-teams",
	WORK_ORDERS_STATUS_BY_REGIONS_AND_FUNCTIONAL_TEAMS:
		"dashboard/work-orders-status-by-regions-and-functional-teams",
	CASES_STATUS_BY_REGIONS_AND_SERVICE_CATEGORIES:
		"dashboard/cases-status-by-regions-and-service-categories",
	WORK_ORDERS_STATUS_BY_REGIONS_AND_SERVICE_CATEGORIES:
		"dashboard/work-orders-status-by-regions-and-service-categories",
	CASES_BY_SERVICE_CATEGORIES_AND_PRIORITY:
		"dashboard/cases-by-service-categories-and-priority",
	TOP_10_CUSTOMERS_BY_ACTIVE_CASES:
		"dashboard/top-10-customers-by-active-cases",
};
